export default "__VITE_ASSET__BQ0AgZxL__"